import {
  Flex,
  type FlexProps,
  PDF_BORDER,
  ReportSectionItemContent,
  SECTION_TITLE_BACKGROUND_COLOR,
} from '@/components';
import type { FC, ReactNode } from 'react';

export const NestedContentItem: FC<{
  mainRowData: Array<{
    label?: string;
    value: ReactNode;
    wrapperStyle?: FlexProps['style'];
  }>;
  subRowsData?: Array<{
    label?: string;
    value: ReactNode;
  }>;
  labelWidth?: number;
  isLast?: boolean;
}> = ({ mainRowData, subRowsData, labelWidth = 150, isLast }) => {
  const nestedLevelWidth = 24;
  return (
    <>
      <Flex>
        {mainRowData.map((data, idx) => {
          const isFirst = idx === 0;
          return (
            <ReportSectionItemContent
              key={data.label}
              label={data.label}
              value={data.value}
              labelStyle={{
                width: labelWidth,
                minWidth: labelWidth,
              }}
              wrapperStyle={{
                height: 'auto',
                borderBottom: 'none',
                borderLeft: isFirst ? 'none' : PDF_BORDER.THIN,
                ...data.wrapperStyle,
              }}
            />
          );
        })}
      </Flex>
      {subRowsData?.map((data, i, array) => {
        const isLastElement = i === array.length - 1;
        const borderBottom =
          isLastElement && !isLast ? PDF_BORDER.THIN : undefined;

        return (
          <Flex key={i.toString()}>
            <div
              style={{
                background: SECTION_TITLE_BACKGROUND_COLOR,
                borderBottom,
                width: nestedLevelWidth,
                boxSizing: 'border-box',
              }}
            />
            <ReportSectionItemContent
              label={data.label}
              value={data.value}
              labelStyle={{
                width: labelWidth - nestedLevelWidth,
                minWidth: labelWidth - nestedLevelWidth,
              }}
              wrapperStyle={{
                height: 'auto',
                borderTop: PDF_BORDER.THIN,
                borderLeft: PDF_BORDER.THIN,
                marginLeft: -1,
                borderBottom,
              }}
            />
          </Flex>
        );
      })}
    </>
  );
};
